import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/provider/complexbar'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class ComplexBarApi {

    static async loadProducts({ data = undefined, ...params }) {
        return await fetchService({ url: '/loadproducts', method: 'POST', data, ...params })
    }


}